import axios from 'axios';
import { ADMIN_HORMONE_PATTERN_ROUTE } from '../../api/backend';
import { HormonePatternApiResponse } from '../../common/model/dto/hormone-pattern/hormone-pattern-api-response';

export const getHormonePattern = async (
  userId: string,
  numberOfScans: number
): Promise<HormonePatternApiResponse> => {
  const { data } = await axios.get<HormonePatternApiResponse>(
    `${ADMIN_HORMONE_PATTERN_ROUTE}/detect/${userId}?number_of_scans=${numberOfScans}`
  );

  return data;
};
